/* =========================================================================
   Cashify Play - MOBILE CART: price breakdown behind a "View breakup" link.
   -------------------------------------------------------------------------
   Subtotal / Discount / Total move into a popover opened from the sticky
   bottom bar. "You save ..." and the trust row (Zero deposit / Tested /
   Free delivery) stay visible in the summary card. Desktop is unaffected.

   WHY A TEXT LINK, NOT AN (i) ICON
   The first version used a 22px (i) circle sitting inline next to the total,
   immediately left of "Proceed to Checkout". On a phone that is a mis-tap
   magnet - aiming for the icon frequently hit checkout instead. It is now a
   "View breakup" link on its own line under the amount, well clear of the
   button, with a full-width-safe tap target. The bar is taller to fit it.

   Lives in an asset rather than sections/cart-template.liquid so a failure
   is inert: if the nodes aren't found, nothing is built and the cart
   behaves exactly as it does today.

   The rows are CLONED, not moved - desktop renders from the same DOM and
   must keep its own Subtotal/Discount/Total. Clones are rebuilt whenever
   the cart section is re-rendered, so they cannot drift.
   ========================================================================= */
(function () {
  var CSS =
    '@media (max-width:991px){' +
      '.cp-summary h3{display:none;}' +
      '.cp-sum-toggle{display:none !important;}' +
      '.cp-sum-rows{display:none !important;}' +
      '.cp-summary.is-open .cp-sum-rows{display:none !important;}' +
      '.cp-summary > .cp-sum-row--total{display:none;}' +
      '.cp-summary{padding:16px;}' +
      '.cp-summary .cp-sum-save{margin-top:0;}' +

      /* Taller bar so the link below the amount has room and is nowhere near
         the checkout button. */
      '.cp-cart-bar{align-items:center;padding:12px 16px calc(12px + env(safe-area-inset-bottom)) !important;}' +
      '.cp-cart-bar__info{flex:1 1 auto;min-width:0;align-items:flex-start;}' +

      /* The total wrapped to "Rs." / "5,703.00" on two lines. Keep the amount
         on one line, and let the button - not the price - give up space. */
      '.cp-cart-bar__val{white-space:nowrap;}' +
      '.cp-cart-bar__label{white-space:nowrap;}' +
      '.cp-cart-bar__btn{flex:0 1 auto;min-width:0;}' +

      '.cp-bar-breakup{appearance:none;-webkit-appearance:none;background:none;border:0;' +
        'margin:2px 0 0;padding:4px 2px 0 0;cursor:pointer;font-family:inherit;' +
        'font-size:13px;font-weight:600;line-height:1.2;color:#7C3AED;' +
        'display:inline-flex;align-items:center;gap:5px;min-height:30px;' +
        'text-decoration:underline;text-underline-offset:3px;}' +
      '.cp-bar-breakup .cp-caret{font-size:10px;transition:transform .2s;}' +
      '.cp-bar-breakup[aria-expanded="true"] .cp-caret{transform:rotate(180deg);}' +

      /* Content and the guard note both have to clear the taller bar. */
      '.cart-page{padding-bottom:124px !important;}' +
      '#cpga-guard-note{position:fixed;left:10px;right:10px;bottom:112px;z-index:9998;' +
        'margin:0;box-shadow:0 4px 18px rgba(0,0,0,.18);}' +

      '.cp-bar-breakdown{position:absolute;left:16px;right:16px;bottom:calc(100% + 10px);' +
        'background:#fff;border:1px solid #e6e6e6;border-radius:12px;' +
        'box-shadow:0 6px 24px rgba(0,0,0,.16);padding:4px 14px 8px;text-align:left;}' +
      '.cp-bar-breakdown[hidden]{display:none;}' +
      '.cp-bar-breakdown .cp-sum-row{padding:8px 0;}' +
      '.cp-bar-breakdown .cp-sum-row--total{display:flex;}' +
    '}';

  /* Loaded from <head>, so the styles land before the cart paints - the rows
     never flash on screen before being hidden. */
  try {
    if (!document.getElementById('cp-bar-breakdown-css')) {
      var st = document.createElement('style');
      st.id = 'cp-bar-breakdown-css';
      st.textContent = CSS;
      (document.head || document.documentElement).appendChild(st);
    }
  } catch (e) {}

  function stripIds(node) {
    if (node.removeAttribute) node.removeAttribute('id');
    var kids = node.querySelectorAll ? node.querySelectorAll('[id]') : [];
    Array.prototype.forEach.call(kids, function (k) { k.removeAttribute('id'); });
    return node;
  }

  function build() {
    var bar = document.querySelector('.cp-cart-bar');
    var info = document.querySelector('.cp-cart-bar__info');
    var summary = document.querySelector('.cp-summary');
    if (!bar || !info || !summary) return;
    if (bar.querySelector('.cp-bar-breakup')) return; /* already built */

    var panel = document.createElement('div');
    panel.className = 'cp-bar-breakdown';
    panel.id = 'cp-bar-breakdown';
    panel.hidden = true;

    var rows = summary.querySelector('.cp-sum-rows');
    if (rows) {
      Array.prototype.forEach.call(rows.children, function (r) {
        panel.appendChild(stripIds(r.cloneNode(true)));
      });
    }
    var total = summary.querySelector('.cp-sum-row--total');
    if (total) panel.appendChild(stripIds(total.cloneNode(true)));

    if (!panel.children.length) return; /* nothing to show - leave the cart alone */

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cp-bar-breakup';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'cp-bar-breakdown');
    btn.innerHTML = 'View breakup <span class="cp-caret">&#9662;</span>';

    /* Under the amount, inside the left-hand info column - as far from the
       checkout button as the bar allows. */
    info.appendChild(btn);
    bar.appendChild(panel);

    function setOpen(open) {
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    /* type=button + stopPropagation matter: this sits inside the cart <form>,
       so a stray submit would send the customer straight to checkout. */
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      setOpen(panel.hidden);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) setOpen(false);
    });
  }

  var bt;
  function rebuild() { clearTimeout(bt); bt = setTimeout(build, 120); }
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
  document.addEventListener('cart:refresh', rebuild);
  try { new MutationObserver(rebuild).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();